import axios from 'axios';
import Cookies from 'js-cookie';
const BASE_URL = process.env.REACT_APP_BPF_SERVER_URL;

const api = axios.create({
    baseURL: `${BASE_URL}/api/bpf/`,
    transformRequest: [(data, headers) => {
        headers['Authorization'] = `Bearer ${Cookies.get('access_token')}`
        return data
    }, ...axios.defaults.transformRequest],
})

api.interceptors.response.use(response => response, error => {
    if (error.response) {
        const code = error.response.status
        const response = error.response.data

        if (code === 401) {
            setTimeout(async () => {
                await localStorage.clear()
                await Cookies.remove('name_bpf');
                await Cookies.remove('permissions_bpf');
                await Cookies.remove('access_token');;
                await window.location.assign('#/Login')
            }, 2000)
        }

        return Promise.reject(response)
    }
})

// Mensagem de erro da API para mostrar ao usuário. O interceptor acima rejeita
// com o CORPO da resposta (não com o erro do axios), então `message` vem na
// raiz; o formato do axios fica de reserva para chamadas fora deste cliente.
export const apiErrorMessage = (err, fallback) => {
    if (err && typeof err.message === 'string' && err.message && !err.isAxiosError) {
        return err.message
    }
    const data = err && err.response && err.response.data
    return (data && data.message) || fallback
}

export default api;